import * as actionTypes from './actionTypes';
import axios from '../../axios';

export const createPaymentStart = () => {
  return {
    type: actionTypes.CREATE_PAYMENT_START,
  };
};

export const createPaymentSuccess = (payment) => {
  return {
    type: actionTypes.CREATE_PAYMENT_SUCCESS,
    payment: payment,
  };
};

export const createPaymentFailed = (error) => {
  return {
    type: actionTypes.CREATE_PAYMENT_FAILED,
    error: error,
  };
};

export const createPayment = (data) => {
  return (dispatch) => {
    dispatch(createPaymentStart());
    axios
      .post('payments/create', data)
      .then((response) => {
        dispatch(createPaymentSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(createPaymentFailed(err));
      });
  };
};

export const evaluatePaymentStart = () => {
  return {
    type: actionTypes.EVALUATE_PAYMENT_START,
  };
};

export const evaluatePaymentSuccess = (payment) => {
  return {
    type: actionTypes.EVALUATE_PAYMENT_SUCCESS,
    payment: payment,
  };
};

export const evaluatePaymentFailed = (error) => {
  return {
    type: actionTypes.EVALUATE_PAYMENT_FAILED,
    error: error,
  };
};

export const evaluatePayment = (data) => {
  return (dispatch) => {
    dispatch(evaluatePaymentStart());
    axios
      .patch('payments/evaluate', data)
      .then((response) => {
        dispatch(evaluatePaymentSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(evaluatePaymentFailed(err));
      });
  };
};

export const fetchPaymentsStart = () => {
  return {
    type: actionTypes.FETCH_PAYMENTS_START,
  };
};

export const fetchPaymentsSuccess = (payments, pagination) => {
  return {
    type: actionTypes.FETCH_PAYMENTS_SUCCESS,
    payments: payments,
    pagination: pagination,
  };
};

export const fetchPaymentsFailed = (error) => {
  return {
    type: actionTypes.FETCH_PAYMENTS_FAILED,
    error: error,
  };
};

export const fetchPayments = ({ pageIndex, pageSize }) => {
  return (dispatch) => {
    dispatch(fetchPaymentsStart());
    axios
      .get('payments', {
        params: {
          page: pageIndex + 1,
          limit: pageSize,
        },
      })
      .then((response) => {
        dispatch(
          fetchPaymentsSuccess(response.data.data, response.data.pagination)
        );
      })
      .catch((err) => {
        dispatch(fetchPaymentsFailed(err));
      });
  };
};

export const filterPaymentsStart = () => {
  return {
    type: actionTypes.FILTER_PAYMENTS_START,
  };
};

export const filterPaymentsSuccess = (payments, pagination) => {
  return {
    type: actionTypes.FILTER_PAYMENTS_SUCCESS,
    payments: payments,
    pagination: pagination,
  };
};

export const filterPaymentsFailed = (error) => {
  return {
    type: actionTypes.FILTER_PAYMENTS_FAILED,
    error: error,
  };
};

export const filterPayments = (data) => {
  return (dispatch) => {
    const { status, from, to, pageIndex, pageSize } = data;
    dispatch(fetchPaymentsStart());
    axios
      .get('payments/filter', {
        params: {
          status,
          from,
          to,
          page: pageIndex + 1,
          limit: pageSize,
        },
      })
      .then((response) => {
        dispatch(
          filterPaymentsSuccess(response.data.data, response.data.pagination)
        );
      })
      .catch((err) => {
        dispatch(filterPaymentsFailed(err));
      });
  };
};

export const exportPaymentsStart = () => {
  return {
    type: actionTypes.EXPORT_PAYMENTS_START,
  };
};

export const exportPaymentsSuccess = (exportedPayments) => {
  return {
    type: actionTypes.EXPORT_PAYMENTS_SUCCESS,
    exportedPayments: exportedPayments,
  };
};

export const exportPaymentsFailed = (error) => {
  return {
    type: actionTypes.EXPORT_PAYMENTS_FAILED,
    error: error,
  };
};

export const exportPayments = ({ status, from, to }) => {
  return (dispatch) => {
    dispatch(exportPaymentsStart());
    axios
      .get('payments/export', {
        params: {
          status,
          from,
          to,
        },
      })
      .then((response) => {
        dispatch(exportPaymentsSuccess(response.data.data));
      })
      .catch((err) => {
        dispatch(exportPaymentsFailed(err));
      });
  };
};

export const resetPayments = () => {
  return {
    type: actionTypes.RESET_PAYMENTS,
  };
};
